import React, { FC, ReactNode } from 'react';
import { Box, Dialog, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import { CloseIcon } from 'svgs';

export interface ModalDialogProps {
  open: boolean;
  onClose: () => void;
  maxWidth: number;
  children: ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.4)' },
  },
  paper: {
    overflowY: 'unset',
    borderRadius: 0,
    minWidth: 345,
    width: '99%',
    overflowX: 'unset',
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(40, 0),
    [theme.breakpoints.up('sm')]: {
      maxWidth: (props: ModalDialogProps) => props.maxWidth,
    },
  },
  icon: {
    backgroundColor: theme.palette.primary.main,
    padding: 10,
    right: 0,
    top: 0,
    cursor: 'pointer',
    maxHeight: 50,
  },
  name: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  position: {
    fontWeight: 500,
    color: theme.palette.primary.light,
  },
  divider: {
    maxWidth: 100,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    marginBottom: theme.spacing(4),
  },
  content: {
    padding: theme.spacing(10, 0, 5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(10, 4, 5),
    },
  },
}));

const ModalDialog: FC<ModalDialogProps> = (props) => {
  const { open, onClose, children, maxWidth } = props;
  const classes = useStyles(props);
  const isLarge = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <Dialog
      onClose={onClose}
      open={open}
      disableScrollLock={isLarge}
      scroll={!isLarge ? 'body' : 'paper'}
      className={classes.root}
      classes={{ paper: classes.paper }}
    >
      <Box position="relative">
        <Box position="absolute" className={classes.icon} onClick={onClose}>
          <CloseIcon />
        </Box>
      </Box>
      <Box className={classes.content}>{children}</Box>
    </Dialog>
  );
};

export default ModalDialog;
